import css from "../../css/my-property/map.module.css";

import React, { useState } from "react";
import PropTypes from "prop-types";
import Marker from "./Marker";
import GoogleMapReact from "google-map-react";

const Map = (props) => {
    const { latitude, longitude, address } = props;
    const googleMapsApiKey = process.env.GOOGLE_MAPS_KEY;

    const [showAddress, setShowAddress] = useState(props.showAddress);

    const handleAddress = () => {
        if (!props.showAddress) {
            setShowAddress(!showAddress);
        }
    };

    const center = {
        lat: latitude,
        lng: longitude,
    };

    const zoom = 15;

    return (
        <div className={css.map}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: googleMapsApiKey }}
                defaultCenter={center}
                defaultZoom={zoom}
                onChildMouseLeave={handleAddress}
                onChildMouseEnter={handleAddress}
                options={{
                    mapTypeControl: true,
                }}
            >
                <Marker
                    key={address}
                    address={address}
                    showAddress={showAddress}
                    lat={latitude}
                    lng={longitude}
                />
            </GoogleMapReact>
        </div>
    );
};

Map.propTypes = {
    address: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    showAddress: PropTypes.bool,
};

Map.defaultProps = {
    showAddress: false,
};

export default Map;
